import { Dividends } from 'actions';

const initialState = {
  isFetching: false,
  table: [],
  total: {},
  excluded: [],
  portfolioValue: {},
  annualDividend: {},
  dividendYield: null,
  accounts: [],
  preSelectedAccounts: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Dividends.DIVIDENDS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case Dividends.DIVIDENDS_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        accounts: action.accounts,
        table: action.data.table || [],
        total: action.data.total || {},
        excluded: action.data.excluded || [],
        portfolioValue: action.data.portfolio_value || {},
        annualDividend: action.data.annual_dividend || {},
        dividendYield:
          action.data.dividend_yield !== undefined
            ? action.data.dividend_yield
            : null,
      };
    case Dividends.DIVIDENDS_FETCH_FAIL:
      return {
        ...state,
        isFetching: false,
      };
    case Dividends.DIVIDENDS_SET_SELECTED_ACCOUNTS:
      return {
        ...state,
        preSelectedAccounts: action.accounts,
      };
    case Dividends.DIVIDENDS_CLEAR:
      return initialState;
    default:
      return state;
  }
}
